<template>
  <div class="star">
    <font v-for="i in 5" :key="i" class="iconfont color_999" @click="handler(i)"
          :class="[sizeClass,i<=current?'cover':'']">&#xe664;</font>
    <slot name="scorewrap"></slot>
  </div>
</template>

<script>
  /**
   * props
   * **** score
   * **** click
   * **** size
   *
   * slot
   * **** scorewrrap
   */
  export default {
    name: 'v-star',
    props: {
      score: [Number, String],
      click: Boolean,
      size: String
    },
    data() {
      return {
        current: -1
      };
    },
    computed: {
      sizeClass() {
        let className = '';
        switch (this.size) {
          case 'big':
            className = 'weui-icon-size26';
            break;
          case 'small':
            className = 'weui-icon-size12';
            break;
        }
        return className;
      }
    },
    components: {},
    mixins: [],
    created() {
      if (this.score) {
        this.current = Math.floor(this.score - 1) + 1;
      }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
      handler(index) {
        if (this.click) {
          this.current = index;
          this.$emit('change', index);
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .cover {
    color: orange;
  }
</style>



// WEBPACK FOOTER //
// src/plugins/star.vue